import React, { useState } from "react";
import { FaClock } from "react-icons/fa";
import { useGetPaymentDetails } from "../../services/queries";
import { useTranslation } from "react-i18next";
import logo from '../../assets/Navbar/Regency Plaza Hotels 2.png'
export default function BookingHistory() {
  const { i18n,t } = useTranslation();
  const { data: paymentDetails } = useGetPaymentDetails(i18n.language);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const formatDate = (dateStr) => {
    const options = { weekday: "short", month: "short", day: "numeric" };
    return new Date(dateStr).toLocaleDateString(i18n.language, options);
  };

  const getCurrencySymbol = (currency) => {
    return currency === 0 ? "EGP" : "$";
  };
  const handleViewDetails = (booking) => {
    setSelectedBooking(booking);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedBooking(null);
    setShowModal(false);
  };
  return (
    <>
      {paymentDetails?.map((booking) => (
        <div key={booking.id} className="card p-3 border-0 rounded-4 mb-3 bg-white">
          <div className="d-flex align-items-center">
            {/* Hotel Logo */}
            <img
              src={logo}
              alt="Hotel Logo"
              className="rounded-circle me-3"
            />

            {/* Booking Details */}
            <div className="flex-grow-1">
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <div className="text-muted">{t("checkIn")}</div>
                  <div className="fw-bold">{formatDate(booking.startDate)}</div>
                </div>
                <div className="fw-bold">—</div>
                <div className="ms-3">
                  <div className="text-muted">{t("checkOut")}</div>
                  <div className="fw-bold">{formatDate(booking.endDate)}</div>
                </div>
              </div>

              {/* Check-in & Check-out Times */}
              <div className="d-flex mt-2">
                {/* <div className="me-3 d-flex align-items-center">
                  <FaClock className="text-primary me-1" />
                  <span className="text-muted">{t("checkInTime")}</span>{" "}
                  <b className="ms-1">12:00pm</b>
                </div>
                <div className="me-3 d-flex align-items-center">
                  <FaClock className="text-primary me-1" />
                  <span className="text-muted">Check-Out</span>{" "}
                  <b className="ms-1">11:30am</b>
                </div> */}
                <div className="d-flex align-items-center">
                  {/* <FaClock className="text-primary me-1" /> */}
                  <span className="text-muted">{t("room")}</span>{" "}
                  <b className="ms-1">{booking.roomName}</b>
                </div>
              </div>

              {/* Total and Status */}
              <div className="mt-2">
                <span className="fw-bold">
                  {getCurrencySymbol(booking.currency)} {booking.total}
                </span>{" "}
                - <span className="text-capitalize">{booking.status}</span>
              </div>
            </div>

            {/* Buttons */}
            <div className="d-flex align-items-center">
              {/* <button className="btn btn-primary me-2">Download</button> */}
              <button onClick={() => handleViewDetails(booking)} className="btn btn-outline-secondary">{">"}</button>
            </div>
          </div>
        </div>
      ))}
        {/* Modal */}
        {showModal && selectedBooking && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content rounded-4">
              <div className="modal-header">
                <h5 className="modal-title">{t("bookingDetails")}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <p><strong>{t("hotel")}:</strong> {selectedBooking.hotelName}</p>
                <p><strong>{t("room")}:</strong> {selectedBooking.roomName}</p>
                <p><strong>{t("checkIn")}:</strong> {formatDate(selectedBooking.startDate)}</p>
                <p><strong>{t("checkOut")}:</strong> {formatDate(selectedBooking.endDate)}</p>
                <p><strong>{t("status")}:</strong> {selectedBooking.status}</p>
                <p><strong>{t("total")}:</strong> {getCurrencySymbol(selectedBooking.currency)} {selectedBooking.total}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  {t("close")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
